import { SELECIONAR_DESTINO } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarDestino (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_DESTINO: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
